// Utils
import { asObject } from '../../../common/utils/immutableHelper';
import { getBackground, getElementId } from '../../../common/elements/utils/elementPropertyUtils';
import { getElement } from '../../../common/elements/utils/elementTraversalUtils';

// Selectors
import { getCurrentBoard, getCurrentBoardId } from '../../element/selectors/currentBoardSelector';
import { getElements } from '../../element/selectors/elementsSelector';

// Actions
import { updateElement } from '../../element/actions/elementActions';

const updateElementBoardBackground =
    ({ elementId, backgroundChanges, transactionId }) =>
    (dispatch, getState) => {
        const state = getState();
        const elements = getElements(state);

        const board = getElement(elements, elementId);

        if (!board) return;

        const background = asObject(getBackground(board));

        return dispatch(
            updateElement({
                id: elementId,
                changes: {
                    background: {
                        ...background,
                        ...backgroundChanges,
                    },
                },
                transactionId,
            }),
        );
    };

export const updateCurrentBoardBackground = (backgroundChanges) => (dispatch, getState) => {
    const state = getState();
    const currentBoardId = getCurrentBoardId(state);

    if (!currentBoardId) return;

    return dispatch(updateElementBoardBackground({ elementId: currentBoardId, backgroundChanges }));
};

export const resetBoardBackgroundToDefault = () => (dispatch, getState) => {
    const state = getState();
    const currentBoard = getCurrentBoard(state);

    if (!currentBoard) return;

    return dispatch(
        updateElement({
            id: getElementId(currentBoard),
            changes: {
                background: null,
            },
        }),
    );
};
